export var EventsRequestType;
(function (EventsRequestType) {
    EventsRequestType["ByCouponId"] = "ByCouponId";
    EventsRequestType["ByTopLeagues"] = "ByTopLeagues";
    EventsRequestType["ByEventIds"] = "ByEventIds";
    EventsRequestType["ByLeagueIds"] = "ByLeagueIds";
    EventsRequestType["ByRegionId"] = "ByRegionId";
    EventsRequestType["ByPersonalization"] = "ByPersonalization";
})(EventsRequestType || (EventsRequestType = {}));
//# sourceMappingURL=EventsRequest.js.map